<form [formGroup]="form">
  <div id="filter-grid">
    <div *ngIf="isAdmin">
      <label>Cities</label>
      <div class="chip" mdbDropdown *ngIf="isAdmin">
        <div mdbDropdownToggle>
          {{ form.controls.city.value }}
          <mdb-icon fas icon="chevron-down" class="close"></mdb-icon>
        </div>

        <div class="dropdown-menu dropdown-primary">
          <a class="dropdown-item" (click)="resetCity()">All</a>
          <div class="divider dropdown-divider"></div>
          <div
            class="dropdown-item"
            *ngFor="let city of cities"
            (click)="changeCity(city)"
          >
            {{ city.city_name + ", " + city.state }}
          </div>
        </div>
      </div>
    </div>

    <!-- Venues -->
    <div id="venue_opts">
      <label>
        Venues
      </label>
      <div class="chip" mdbDropdown>
        <div mdbDropdownToggle>
          {{ form.controls.venue.value }}
          <mdb-icon fas icon="chevron-down" class="close"></mdb-icon>
        </div>
        <div class="dropdown-menu dropdown-primary">
          <a class="dropdown-item" (click)="resetVenue()">All</a>
          <div class="divider dropdown-divider"></div>
          <a
            class="dropdown-item"
            *ngFor="let venue of venues"
            (click)="changeVenue(venue)"
            >{{ venue.name }}</a
          >
        </div>
      </div>
    </div>

    <!-- Product Type -->
    <div id="product_type_opts">
      <label> Product Type </label>

      <div class="chip" mdbDropdown>
        <div mdbDropdownToggle>
          {{ form.controls.productType.value }}
          <mdb-icon fas icon="chevron-down" class="close"></mdb-icon>
        </div>
        <div class="dropdown-menu dropdown-primary">
          <a class="dropdown-item" (click)="resetType()">All</a>
          <div class="divider dropdown-divider"></div>
          <a
            class="dropdown-item"
            *ngFor="let type of types"
            (click)="changeType(type)"
            >{{ type }}</a
          >
        </div>
      </div>
    </div>

    <!-- Day of Week -->
    <div id="dow_opts">
      <label> Day Of Week </label>

      <div class="chip" mdbDropdown>
        <div mdbDropdownToggle>
          {{ form.controls.dow.value }}
          <mdb-icon fas icon="chevron-down" class="close"></mdb-icon>
        </div>
        <div class="dropdown-menu dropdown-primary">
          <mdb-tree
            (checked)="onCheck($event)"
            (nodesChanged)="changeDOW($event)"
            [checkboxes]="true"
            textField="name"
            childrenField="children"
            checkboxesField="checked"
            [toggleOnTitleClick]="false"
            [nodes]="dow"
          ></mdb-tree>
        </div>
      </div>
    </div>

    <!-- Timeframe -->
    <div id="time_opts">
      <label> Timeframe </label>

      <div class="chip" mdbDropdown>
        <div mdbDropdownToggle>
          {{ form.controls.timeframe.value }}
          <mdb-icon fas icon="chevron-down" class="close"></mdb-icon>
        </div>
        <div class="dropdown-menu dropdown-primary">
          <a
            class="dropdown-item"
            *ngFor="let tf of objectKeys(timeframes)"
            (click)="changeTimeframe(tf)"
            >{{ tf }}</a
          >
        </div>
      </div>
    </div>

    <div class="filter-container" *ngIf="fb.analytics == null">
      <div class="spinner-grow justify-self-center" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</form>
